import { ThemeSwitch } from "@/components/theme-switch";
import EcosuiteLogo from "@/assets/ecosuite.svg";

interface Props {
  children: React.ReactNode;
}

export default function AuthLayout({ children }: Readonly<Props>) {
  return (
    <div>
      <div className="absolute right-4 top-4">
        <ThemeSwitch />
      </div>
      <div className="container grid h-svh flex-col items-center justify-center bg-zinc-100 lg:max-w-none lg:px-0 dark:bg-zinc-900">
        <div className="mx-auto flex w-full flex-col justify-center space-y-2 sm:w-[480px] lg:p-8">
          <div className="mb-4 flex flex-col items-center justify-center space-y-4">
            <div className="flex items-center gap-2">
              <img
                src={EcosuiteLogo}
                className="relative"
                width={30}
                height={30}
                alt="Ecosuite"
              />
              <h1 className="text-xl font-medium">Ecosuite Admin</h1>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
